<script setup>
import { useForm } from '@inertiajs/inertia-vue3'

const props = defineProps({
	commentableTbl: {
		type: String,
		default: null,
	},
	commentableId: {
		type: Number,
		default: null,
	},
})

const form = useForm({
	commentable_tbl: props.commentableTbl,
	commentable_id: props.commentableId,
	content: null,
})

const submit = () => {
	form.post(route('member.post.store_comment'), {
		preserveScroll: true,
		preserveScroll: true,
		onSuccess: () => form.reset('content'),
	})
}
</script>

<template>
	<div class="d-flex mb-4">
		<img
			v-if="$page.props.userRole === 'Admin'"
			class="img-avatar img-avatar48 me-3 user-avatar d-flex"
			:src="
				'https://ui-avatars.com/api/?size=128&background=fad859&color=fff&font-size=0.5&bold=true&length=1&name=' +
				$page.props.user.full_name
			"
		/>
		<img
			v-else
			class="img-avatar img-avatar48 me-3 user-avatar d-flex"
			:src="
				$page.props.user.avatar === 'default-avatar.png'
					? 'https://ui-avatars.com/api/?size=128&background=fad859&color=fff&font-size=0.5&bold=true&length=1&name=' +
					  $page.props.user.full_name
					: '/avatar/' + $page.props.user.avatar
			"
			alt="avatar"
		/>
		<div class="flex-grow-1">
			<form @submit.prevent="submit">
				<div class="mb-4">
					<textarea
						v-model="form.content"
						rows="5"
						class="form-control"
						:class="{ 'is-invalid': form.errors.content }"
						placeholder="Write a response.."
					></textarea>
					<div v-if="form.errors.content" class="invalid-feedback">
						{{ form.errors.content }}
					</div>
				</div>
				<button type="submit" class="btn btn-alt-primary">
					<i class="fa fa-reply opacity-50 me-1"></i> Respond
				</button>
			</form>
		</div>
	</div>
</template>
